module.exports = require("mdi-react/InformationOutlineIcon");